import Chip, { type ChipProps } from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import { humanize } from "../utils/format.ts";
import { isJobActive } from "../utils/status.ts";
import { type StatusChipKind, statusStyle } from "../utils/statusColors.ts";

interface StatusChipProps {
  /** Which vocabulary `value` is from (`utils/statusColors.ts`). */
  kind: StatusChipKind;
  value: string;
  /** Overrides the registry's label (or the humanized value). */
  label?: string;
  variant?: ChipProps["variant"];
}

/**
 * A status as a coloured chip, coloured and labelled by the shared registry.
 * A job still in flight (pending, queued, running) spins.
 */
export default function StatusChip({ kind, value, label, variant }: StatusChipProps) {
  const style = statusStyle(kind, value);
  const spinning = kind === "job" && isJobActive(value);
  return (
    <Chip
      size="small"
      color={style.color}
      variant={variant}
      icon={spinning ? <CircularProgress size={12} thickness={5} color="inherit" disableShrink /> : undefined}
      label={label ?? style.label ?? humanize(value)}
    />
  );
}
